import { render, staticRenderFns } from "./speechcraftList.vue?vue&type=template&id=4bd6abe8&scoped=true&"
import script from "./speechcraftList.vue?vue&type=script&lang=js&"
export * from "./speechcraftList.vue?vue&type=script&lang=js&"
import style0 from "./speechcraftList.vue?vue&type=style&index=0&id=4bd6abe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd6abe8",
  null
  
)

export default component.exports